import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=2e6cd552&"
import script from "./Watchlist.vue?vue&type=script&lang=js&"
export * from "./Watchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6cd552')) {
      api.createRecord('2e6cd552', component.options)
    } else {
      api.reload('2e6cd552', component.options)
    }
    module.hot.accept("./Watchlist.vue?vue&type=template&id=2e6cd552&", function () {
      api.rerender('2e6cd552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/watchlist/Watchlist.vue"
export default component.exports